import axiosInstance from '../api/axiosInstance';

export interface Permission {
  id: number;
  role: string;
  branchId: number;
  branchName: string;
  createdAt: string;
}

export interface Branch {
  id: number;
  name: string;
  role: string;
}

export interface User {
  id: number;
  uid: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  username: string;
  image: string | null;
  createdAt: string;
  updatedAt: string;
  role: string;
  roles: string[];
  permissions: Permission[];
  branches: Branch[];
  isActive: boolean;
}

export interface GetUsersParams {
  search?: string;
  role?: string;
  status?: string;
}

export interface CreateUserData {
  firstName: string;
  lastName: string;
  username: string;
  phoneNumber: string;
  password: string;
  role: string;
  branches?: Array<{
    id: string;
    role: string;
  }>;
  branchId?: number;
  status: 'active' | 'inactive';
  image?: string | null;
}

export interface UpdateUserData extends Omit<CreateUserData, 'password'> {
  password?: string;
}

export const userManagementAPI = {
  getUsers: async (params?: GetUsersParams): Promise<User[]> => {
    const response = await axiosInstance.get('/company-users/users', {
      params: {
        search: params?.search,
        role: params?.role !== 'all' ? params?.role : undefined,
        status: params?.status !== 'all' ? params?.status : undefined,
      },
    });
    return response.data.data;
  },

  getBranchStats: async (): Promise<{
    branchManagersCount: number;
    branchOwnersCount: number;
    totalBranches: number;
  }> => {
    const response = await axiosInstance.get('/companies/branch-roles/count');
    return response.data;
  },

  deleteUser: async (userId: string): Promise<void> => {
    await axiosInstance.delete(`/company-users/remove-user/${userId}`);
  },

  getUserById: async (id: string): Promise<User> => {
    const response = await axiosInstance.get(`/company-users/users/${id}`);
    return response.data;
  },

  createUser: async (userData: CreateUserData): Promise<User> => {
    const response = await axiosInstance.post(
      '/company-users/create-user',
      userData
    );
    return response.data;
  },

  updateUser: async (id: string, userData: UpdateUserData): Promise<User> => {
    const response = await axiosInstance.put(
      `/company-users/users/${id}`,
      userData
    );
    return response.data;
  },
};
